import { IssueType } from "./IssueType";
import type { IrMap } from "./IrMap";

export class IssueTypeFunctions {
    public static issueTypeIcon: (issueType: IssueType) => string = (issueType: IssueType) => {
        switch (issueType) {
            case IssueType.NoHeartbeatReceived:
                return "heartbeat";
            case IssueType.NoImageReceived:
                return "image";
            case IssueType.NoImageFromCamera:
                return "chart-network";
            case IssueType.ConnectionFailure:
                return "chart-network";
            case IssueType.SystemFailure:
                return "cogs";
            case IssueType.Tampering:
                return "image";
            case IssueType.VideoQualityFailure:
                return "image";
            case IssueType.ConnectionDegraded:
                return "chart-network";
            default:
                return "";
        }
    };

    public static enhanceIssueType(issueTypeString: string) {
        const typeName = issueTypeString as any as keyof typeof IssueType;
        const type = IssueType[typeName];
        return type;
    }

    public static enhanceAlarmIssueTypes(issueTypes: IrMap<string, number>) {
        return issueTypes.map((aet) => ({
            key: this.enhanceIssueType(aet.key),
            value: aet.value,
        }));
    }
}
